import { SectionArray } from "./SectionArray";
import { SectionBody } from "./SectionBody";
import { ISectionRenderProps } from "./SectionRoot";

export const SectionBodyInstances: React.FC<ISectionRenderProps> = (props) => {
	return props.controller.schema.isArray ? (
		<SectionArray controller={props.controller} path={props.sectionPath} />
	) : (
		<SectionBody {...props} canCopy={!!props.canCopy} canDelete={!!props.canDelete} />
	);
};
